import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Badge } from '../Badge/Badge'
export const Counter = ({ label, state, count, className, onClick, maxcount, data }) => {
  function badgeText () {
    switch (state) {
      case 'disabled':
        return '-'
      case 'loading':
        return ''
      case 'active':
        return count
    }
  }

  const propsBadge = () => ({
    text: badgeText(),
    type: (state === 'active' && count > 0) ? 'success' : 'default',
    kind: 'secondary',
    onClick: state === 'active' ? onClick(data) : null,
    className: state === 'loading' ? 'loading' : ''

  })

  const classCounter = classNames(className, {
    'counter_cursor-pointer': state === 'active' && onClick
  })

  const classLabel = classNames('d-inline', {
    'text-light': state !== 'active' || count === 0,
    'text-highlight': state === 'active' && count > 0
  })

  const containerStyle = {
    width: ((maxcount ? maxcount.toString().length : count.toString().length) * 8 + 20 + 15) + 'px'
  }

  return (
    <div className={classCounter} onClick={() => onClick(data)}>
      <div className='d-inline-block' style={containerStyle}>
        {state !== 'loading' && <Badge {...propsBadge()} />}
        {state === 'loading' && <span className='is-loading fix_loading' />}
      </div>
      <h4 className={classLabel}>{label}</h4>
    </div>
  )
}

Counter.defaultProps = {
}

Counter.propTypes = {
  children: PropTypes.node,
  state: PropTypes.oneOf(['disabled', 'loading', 'active']),
  count: PropTypes.number,
  className: PropTypes.string,
  maxCount: PropTypes.number,
  onClick: PropTypes.func
}
